import gql from 'graphql-tag'

export const ItemPastaFragment = gql`
  fragment ItemPastaFragment on ItemBiblioteca {
    id
    nome
    isPasta
    isPublico
    pastaPai {
      id
    }
    proprietario {
      id
      nome
    }
    permissoesAcessoUsuarioLogado {
      id
      description
    }
    permissoes {
      id
      grupoUsuarios {
        id
        nome
        favorito
      }
      permissaoAcessoPasta {
        id
      }
    }
    ultimaModificacao
    dataCriacao
    arquivoLink
    arquivoMiniaturaLink
    arquivoImagem
  }
`
